import { useParams } from "react-router-dom";

import { Video } from "@/routes/video/components/Video";

export default function VideoRoute() {
    const { videoId } = useParams<{ videoId: string }>();

    if (!videoId) {
        return null;
    }

    return <Video id={videoId} />;
}
